module.exports = __webpack_public_path__ + "static/media/collection-icon-empty.569e2688.svg";